import { FC } from "react";
import { Communication } from "../../../types";
import Heading from "../../Common/Heading";
import { StyledWrap, StyledContent } from "./style";

type Props = {
  communication: Communication;
};

const MailBody: FC<Props> = ({ communication }) => {
  return (
    <StyledWrap>
      <Heading as="h5" mb="30px">
        {communication.Subject}
      </Heading>
      {/* <Heading mb="0px" fontWeight={600}>
        Mario Rossi
      </Heading>
      <Text as="span" color="text3">
        Paghe
      </Text> */}
      <StyledContent
        dangerouslySetInnerHTML={{
          __html: communication.Text.replaceAll("\\r", "\r").replaceAll("\\n", "<br/>"),
        }}
      />
    </StyledWrap>
  );
};

export default MailBody;
